import type { JHTML, JHTMLNode, Roost } from "./roost_i";
export * from "./roost_i";
const roost: Roost = {
    convert: (jhtml?: JHTML): string => {
        if (!jhtml) return "";
        let html = "";

        for (const element in jhtml) {
            if (Object.prototype.hasOwnProperty.call(jhtml, element)) {
                const [tag, rawId] = element.split("-");
                
                const attributes = jhtml[element];
                let content = "";

                if (typeof attributes === "object" && attributes !== null) {
                    if ("child" in attributes) {
                        content = typeof attributes.child === "object" && attributes.child !== null
                            ? roost.convert(attributes.child as JHTML) 
                            : String(attributes.child ?? "");
                    }

                    if (tag === "") {
                        html += `${content}`;
                    } else {
                        let obj = `<${tag}`;
                        let isClosed = false;

                        for (const attribute in attributes) {
                            if (attribute === "child") continue;

                            if (attribute === "closed") {
                                isClosed = true;
                            } else if (Object.prototype.hasOwnProperty.call(attributes, attribute)) {
                                const value = attributes[attribute];
                                obj += ` ${attribute}="${String(value)}"`;
                            }
                        }
                        /*          if its closed    />  OR  >           if its closed </tag> or nothing*/
                        html += `${obj}${isClosed ? "/" : ""}>${content}${!isClosed ? `</${tag}>` : ""}`;
                    }
                }
            }
        }
        return html;
    },
    convertJSX: (tag: string | Function | null, props?: any, ...children: any[]): JHTML => {
        const nodeAttributes: JHTMLNode = {};

        if (props && typeof props === "object") {
            for (const key in props) {
                if (Object.prototype.hasOwnProperty.call(props, key)) {
                    nodeAttributes[key] = props[key];
                }
            }
        }

        const validChildren = children.filter(child => child !== null && child !== undefined && child !== "");

        if (validChildren.length > 0) {
            if (validChildren.length === 1) {
                const child = validChildren[0];
                nodeAttributes.child = (typeof child === "object" && child !== null) ?
                                            child
                                        :
                                            String(child);
            } else {
                const childMap: JHTML = {};
                validChildren.forEach((child, idx) => {
                    childMap[`-${idx}`] = {
                        child: (typeof child === "object" && child !== null) ?
                                    child 
                                : 
                                    String(child)
                    };
                });
                nodeAttributes.child = childMap;
            }
        } else {
            nodeAttributes.closed = true;
        }

        let actualTag = (typeof tag === "string") ? tag :"";
        
        const finalTagKey = actualTag === "" ? "-0" : (actualTag.includes("-") ? actualTag : `${actualTag}-0`);

        return {
            [finalTagKey]: nodeAttributes
        };
    },
    extensions: {}
};

export default roost;